"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingPauseStateResponseT = exports.TrackingPauseStateResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class TrackingPauseStateResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackingPauseStateResponse(bb, obj) {
        return (obj || new TrackingPauseStateResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackingPauseStateResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackingPauseStateResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * Skeleton tracking is paused if true, skeleton tracking is unpaused if false.
     */
    trackingPaused() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startTrackingPauseStateResponse(builder) {
        builder.startObject(1);
    }
    static addTrackingPaused(builder, trackingPaused) {
        builder.addFieldInt8(0, +trackingPaused, +false);
    }
    static endTrackingPauseStateResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackingPauseStateResponse(builder, trackingPaused) {
        TrackingPauseStateResponse.startTrackingPauseStateResponse(builder);
        TrackingPauseStateResponse.addTrackingPaused(builder, trackingPaused);
        return TrackingPauseStateResponse.endTrackingPauseStateResponse(builder);
    }
    unpack() {
        return new TrackingPauseStateResponseT(this.trackingPaused());
    }
    unpackTo(_o) {
        _o.trackingPaused = this.trackingPaused();
    }
}
exports.TrackingPauseStateResponse = TrackingPauseStateResponse;
class TrackingPauseStateResponseT {
    constructor(trackingPaused = false) {
        this.trackingPaused = trackingPaused;
    }
    pack(builder) {
        return TrackingPauseStateResponse.createTrackingPauseStateResponse(builder, this.trackingPaused);
    }
}
exports.TrackingPauseStateResponseT = TrackingPauseStateResponseT;
